import { formatNumber } from "../../../../../../helpers/numbers"
import { IntlShape } from "react-intl"

export const getReachPoints = (
	variationDifference: number,
	intl: IntlShape
) => {
	const variationDifferencFormatted = formatNumber(
		variationDifference * 100,
		intl,
		2
	)
	if (variationDifference > 0) return `+${variationDifferencFormatted}`
	return variationDifferencFormatted
}
